import React, { useState, useEffect } from 'react'
import { useHistory } from "react-router-dom";
import i18n from '@dhis2/d2-i18n'
import classes from '../../App.module.css'
import { makeStyles } from '@material-ui/core/styles';
import { apiServices } from '../../services/apiServices'

import { db, auth } from '../../firebaseConfig';

//import SearchBar from '../../component/searchbar/SearchBar';
//import CaseList from './NewThemeCaseList'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import DataTable from 'react-data-table-component';
import Pagination from "@material-ui/lab/Pagination";
import Grid from '@material-ui/core/Grid';
import EditIcon from '@material-ui/icons/Edit';
import CheckOutlined from '@material-ui/icons/CheckOutlined';
import _ from "lodash";
import SearchBar from 'material-ui-search-bar';
import {
    Button,
    ButtonStrip,
    Divider,
    InputFieldFF,
    SingleSelectFieldFF,
    ReactFinalForm,
    hasValue,
    InputField,
    CircularLoader,
    CenteredContent
} from '@dhis2/ui';
import { InputLabel, Select, MenuItem } from '@mui/material';

import { withTranslation, Trans, useTranslation } from 'react-i18next';
import swal from 'sweetalert'
import OfflineDb from '../../db'
import { useGlobalSpinnerActionsContext } from '../../context/GlobalSpinnerContext'

import '../../assets/css/customstyles.css'
import '../../assets/css/theme_blue.css'

import FooterMenu from '../../component/layout/FooterMenu'

const { Form, Field } = ReactFinalForm

function MobileSearch() {
    const history = useHistory();
    const [programData, setProgramData] = useState(null)
    const [sessionUserBoValue, setSessionUserBoValue] = React.useState(null)
    const [UIC, setUIC] = React.useState(null)
    // const [loading,setGlobalSpinner] = useState(false)
    const { t } = useTranslation()
    const setGlobalSpinner = useGlobalSpinnerActionsContext()
    const [usersData, setUsersData] = useState(null)
    const [usersAllData, setAllUsersData] = useState(null)
    const [pastAppointmentsData, setPastAppointmentsData] = useState(null)
    const [ConfigurationFromServer, setConfigurationFromServer] = useState(null);
    const [activeCaseDetails, setActiveCaseDetails] = useState(null);
    const [organisationDetails, setorgDetails] = useState(null)
    const [searchInputValue, setSearchInputValue] = useState('')
    const [filteredData, setFilteredData] = useState(usersData);


    //pagination code
    const [page, setPage] = useState(1);
    const [noOfPages, setNoOfPages] = useState(0)
    const [OUJSON, setOUJSON] = useState(null)
    const [tabValue, setTabValue] = useState(0);
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const isToday = (dateStr) => {
        const today = new Date();
        const date = new Date(dateStr);
        return date.toDateString() === today.toDateString();
    };

    const isTodayOrFuture = (dateStr) => {
        const today = new Date();
        const date = new Date(dateStr);

        // Set both dates to midnight for accurate date-only comparison
        today.setHours(0, 0, 0, 0);
        date.setHours(0, 0, 0, 0);

        return date >= today;
    };

    const todayAppointments = usersData?.filter(user => isTodayOrFuture(user.date));

    //const todayAppointments = usersData?.filter(user => isToday(user.date));


    async function getMetaData() {
        let metadata = await OfflineDb.getDataFromPouchDB('metaData')
        setProgramData(metadata.data)

        let loginDetails = await OfflineDb.getDataFromPouchDB('loginDetails')
        setSessionUserBoValue(loginDetails.data)

        let configurations = await OfflineDb.getDataFromPouchDB('configurations')
        setConfigurationFromServer(configurations.data.configuration)

        let CaseDetails = await OfflineDb.getDataFromPouchDB('activeCaseDetails')
        setActiveCaseDetails(CaseDetails)
        let orgDetails = await OfflineDb.getDataFromPouchDB('orgDetails')
        // console.log("orgDetails", orgDetails)
        setorgDetails(orgDetails.data)
    }

    const [filter, setFilter] = useState('all');

    const handleChange = (event) => {
        const value = event.target.value;
        // console.log("filter", value)
        if (value == "checked") {
            setGlobalSpinner(true)
            getCheckedInList()
        } else if(value == "past") {

            const filtered = value
                ? pastAppointmentsData.filter(user => user.isChecked != true)
                : pastAppointmentsData; // Show all if no filter
            setPastAppointmentsData(filtered)
        } else {
            getPastUsers()
        }
        setFilter(value);

    };

    const getUserList = async () => {
        try {
            const snapshot = await db.collection('appointments')
                .where('isChecked', '!=', true)
                .get();

            const users = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));

            setUsersData(users)
            setAllUsersData(users)
            users.map((obj, i) => {
                users[i]["edit"] = <div className="table-action" onClick={() => newCaseClick(obj)}><Button>Check In</Button></div>
            })
            // console.log("userDoc", users);
            return users;
        } catch (error) {
            console.error("Error fetching users:", error);
            return null;
        }
    };

    const getCheckedInList = async () => {
        try {
            const snapshot = await db.collection('appointments').where('isChecked', '==', true).get();

            const users = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));

            setPastAppointmentsData(users)
            setGlobalSpinner(false)
            // console.log("userDoc", users);
            return users;
        } catch (error) {
            console.error("Error fetching users:", error);
            return null;
        }
    };



    const getPastUsers = async () => {
        try {
            const snapshot = await db.collection('appointments').get();

            const users = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            // console.log("history", users)

            const isPast = (dateStr) => {
                const today = new Date();
                const date = new Date(dateStr);
                return date < today && !isToday(dateStr);
            };

            const pastAppointments = users?.filter(user => isPast(user.date) || user.isChecked == true);

            setPastAppointmentsData(pastAppointments)
        } catch (error) {
            console.error("Error fetching users:", error);
            return null;
        }
    }



    function a11yProps(index) {
        return {
            id: `full-width-tab-${index}`,
            "aria-controls": `full-width-tabpanel-${index}`,
        };
    }

    useEffect(() => {
        setGlobalSpinner(true)
        getMetaData()
    }, [])

    useEffect(() => {
        if (programData != null && sessionUserBoValue != null && ConfigurationFromServer != null && organisationDetails != null) {
            setGlobalSpinner(false)
        }

    }, [programData, sessionUserBoValue, ConfigurationFromServer, organisationDetails])

    useEffect(() => {
        if (organisationDetails != null)
            getUserList()
        getPastUsers()
    }, [programData, organisationDetails])

    useEffect(() => {
        if (tabValue == 1) {
            getPastUsers()
        }
    }, [tabValue])

    const editCase = (row) => {
        // console.log("userdata", row)
    }

    const columns = [

        {
            name: t('Name'),
            selector: row => row["name"]
        },
        {
            name: t('Mobile number'),
            selector: row => row["phoneNumber"]
        },
        {
            name: t('Comments'),
            selector: row => row["comments"]
        },
        {
            name: t('Date'),
            selector: row => row["date"]
        },
        {
            name: t('Facility'),
            selector: row => row["healthFacility"]
        },
        {
            name: t('Check In'),
            selector: row => row.edit
        }
    ]

    const historycolumns = [

        {
            name: t('Name'),
            selector: row => row["name"]
        },
        {
            name: t('Mobile number'),
            selector: row => row["phoneNumber"]
        },
        {
            name: t('Comments'),
            selector: row => row["comments"]
        },
        {
            name: t('Date'),
            selector: row => row["date"]
        },
        {
            name: t('Facility'),
            selector: row => row["healthFacility"]
        }
    ]

    async function generateUIC() {
        try {
            const response = await apiServices.generateUIC("OFWQ7SGDoGc");

            let orgdata = organisationDetails?.ancestors;
            const level3Item = orgdata.find(item => item.level === 3);
            const level4Item = orgdata.find(item => item.level === 4);

            const uic = `${level3Item.code}-${level4Item.name.slice(0, 2).toUpperCase()}-${organisationDetails?.code}-${response.value}`;
            setUIC(uic);
            return uic;
        } catch (err) {
            setGlobalSpinner(false);
            throw err; // Optional: rethrow if you want to handle errors outside
        } finally {
            setGlobalSpinner(false);
        }
    }

    function resetSearch() {
        setSearchInputValue('');
        setUsersData(usersAllData)
    }

    const updateAppointmentCheckedFlag = async (userId, isCheckedValue) => {
        try {
            await db.collection('appointments').doc(userId).update({
                isChecked: isCheckedValue
            });

            // console.log("Appointments flag updated");
        } catch (error) {
            console.error("Error updating appointment flag:", error);
        }
    };

    function newCaseClick(obj) {
        updateAppointmentCheckedFlag(obj.id, true)
    }

    return (
        <section
            className="searchcustombg searchtabmaindiv"
            style={{
                flexGrow: 1,
                padding: "0px !important",
            }}>
            <FooterMenu></FooterMenu>
            <Grid container>
                <Grid item xs={4} sm={4} md={4}>
                    <div className="table-header">
                        <h3 className="text-uppercase zero">
                            <Trans>Appointments</Trans>
                        </h3>
                    </div>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={12} sm={12} md={12}>
                    <SearchBar
                        value={searchInputValue}
                        onChange={(newValue) => setSearchInputValue(newValue)}
                        className="searchbar-block"
                        onCancelSearch={() => resetSearch()}
                    />
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <div className="tabs-container">
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        className="appointmenttabs"
                        variant="fullWidth" // ensures tabs span full width
                        textColor="inherit"
                        TabIndicatorProps={{ style: { backgroundColor: 'white' } }} // optional: white indicator
                    >
                        <Tab label={t('Upcoming appointments')} {...a11yProps(0)} />
                        {/* <Tab label={t('Missed appointments')} {...a11yProps(1)} /> */}
                        <Tab label={t('History')} {...a11yProps(1)} />
                    </Tabs>
                </div>
            </Grid>
            <Grid container>
                {tabValue === 0 && (
                    <Grid item xs={12} className="datatable-block">
                        <DataTable
                            striped
                            responsive
                            pagination
                            fixedHeader
                            columns={columns}
                            data={todayAppointments}
                        />
                    </Grid>
                )}

                {/* {tabValue === 1 && (
                    <Grid item xs={12} className="datatable-block">
                        <DataTable
                            striped
                            responsive
                            pagination
                            fixedHeader
                            columns={columns}
                            data={pastAppointments}
                        />
                    </Grid>
                )} */}

                {tabValue === 1 && (

                    <Grid item xs={12} className="datatable-block">
                        <FormControl fullWidth size="small" className='mb-10px mt-10px filterType'>
                            {/* <InputLabel id="filter-label">Filter</InputLabel> */}
                            <Select
                                labelId="filter-label"
                                id="filter-select"
                                value={filter}
                                label="Filter"
                                onChange={handleChange}
                            >
                                <MenuItem value="all">All</MenuItem>
                                <MenuItem value="past">Past</MenuItem>
                                <MenuItem value="checked">Checked</MenuItem>
                            </Select>
                        </FormControl>
                        <DataTable
                            striped
                            responsive
                            pagination
                            fixedHeader
                            columns={historycolumns}
                            data={pastAppointmentsData}
                        />
                    </Grid>
                )}
            </Grid>
        </section>
    )
}
export default MobileSearch;